module.exports = __webpack_public_path__ + "media/images/athletes/1346-e41d77cd8de44f7e0bd0c17bedfbb319.png";